import type { ChatToolCall } from "../types/chat.types";

const TOOL_TITLES: Record<string, string> = {
  "create-record": "Create record",
  "upsert-record": "Create record",
  "update-record": "Update record",
  "create-note": "Create note",
  "update-note": "Update note",
  "delete-note": "Delete note",
  "create-task": "Create task",
  "update-task": "Update task",
  "delete-task": "Delete task",
  "move-deal-stage-by-deal-id": "Move deal to stage",
  "move-deal-stage-by-deal-and-pipeline": "Move deal to stage",
};

const DESTRUCTIVE_TOOLS = new Set(["delete-note", "delete-task"]);

export function toolConfirmationTitle(name: string): string {
  return TOOL_TITLES[name] ?? name;
}

export function isDestructiveToolCall(toolCall: ChatToolCall): boolean {
  if (toolCall.annotations?.destructiveHint) return true;
  return DESTRUCTIVE_TOOLS.has(toolCall.name);
}

export interface LabeledArgumentRow {
  label: string;
  value: string;
}

export function formatConfirmationArguments(
  name: string,
  args: Record<string, unknown>
): LabeledArgumentRow[] {
  const rows: LabeledArgumentRow[] = [];
  const push = (label: string, key: string) => {
    const v = args[key];
    if (v == null || v === "") return;
    rows.push({ label, value: String(v) });
  };

  push("Title", "title");
  push("Body", "body");
  push("Content", "content");
  push("Due", "dueAt");
  push("Record", "recordId");
  push("Linked record", "linkedRecordId");
  push("Stage", "toStageId");
  push("Stage name", "stageName");
  push("Deal", "dealId");
  push("Pipeline", "pipelineId");

  if (rows.length === 0 && Object.keys(args).length > 0) {
    rows.push({ label: "Details", value: JSON.stringify(args, null, 2) });
  }

  if (rows.length === 0 && name) {
    rows.push({ label: "Tool", value: name });
  }

  return rows;
}
